import { useState } from "react";

import { HealthlinkPracticeForm } from "components/HealthlinkCredentialsModal/HealthlinkPracticeForm/HealthlinkPracticeForm";
import { Button } from "components/ui/Button";
import { Dialog } from "components/ui/Dialog";

export const HealthLinkPracticeModal = ({
  buttonText,
  initialValues,
  buttonVariant = "primary",
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Button variant={buttonVariant} onClick={() => setIsModalOpen(true)}>
        {buttonText || "Add practice details"}
      </Button>
      <Dialog
        title={buttonText || "Add practice details"}
        onClose={() => setIsModalOpen(false)}
        open={isModalOpen}
        width={600}
      >
        <HealthlinkPracticeForm
          initialValues={initialValues}
          closeModal={() => setIsModalOpen(false)}
        />
      </Dialog>
    </>
  );
};
